import { PrimaryButton, Stack } from '@fluentui/react';
import React from 'react';
import { defineMessages } from 'react-intl';
import { BasicModal } from 'src/core/components/BasicModal';
import { LuisText } from 'src/core/components/LuisText';
import { useLocalization } from 'src/core/hooks/useLocalization';

type AmlWarningModalProps = {
    hidden: boolean;
    isExtractionProject: boolean;
    closeModal: () => void;
};

const messages = defineMessages({
    classificationInstructionModalTitle: {
        id: 'customText.AmlWarningModal.classificationInstructionModalTitle',
        defaultMessage: 'There must be at least two classes created in your project'
    },
    nerInstructionModalTitle: {
        id: 'customText.AmlWarningModal.nerInstructionModalTitle',
        defaultMessage: 'There must be at least one entity created in your project'
    },
    classificationInstructionModalContent: {
        id: 'customText.AmlWarningModal.classificationInstructionModalContent',
        defaultMessage: 'Before you to connect to with Azure Machine Learning, you need to have at least two classes created.'
    },
    nerInstructionModalContent: {
        id: 'customText.AmlWarningModal.nerInstructionModalContent',
        defaultMessage: 'Before you to connect to with Azure Machine Learning, you need to have at least one entity created.'
    },
    gotIt: {
        id: 'customText.AmlWarningModal.gotIt',
        defaultMessage: 'Got it'
    }
});

export const AmlWarningModal = (props: AmlWarningModalProps) => {
    const { hidden, isExtractionProject, closeModal } = props;
    const { localize } = useLocalization();
    return (
        <BasicModal
            minWidth={416}
            onDismiss={closeModal}
            hidden={hidden}
            modalProps={{ isModeless: true }}
            shouldRenderFooter={false}
            dialogContentProps={{
                title: isExtractionProject
                    ? localize(messages.nerInstructionModalTitle)
                    : localize(messages.classificationInstructionModalTitle)
            }}>
            <Stack tokens={{ padding: 10, childrenGap: 40 }}>
                <Stack>
                    <LuisText>
                        {isExtractionProject
                            ? localize(messages.nerInstructionModalContent)
                            : localize(messages.classificationInstructionModalContent)}
                    </LuisText>
                </Stack>
                <Stack tokens={{ childrenGap: 10 }} horizontal horizontalAlign="end">
                    <PrimaryButton text={localize(messages.gotIt)} onClick={closeModal} />
                </Stack>
            </Stack>
        </BasicModal>
    );
};
